var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M14.626 7.311a7.292 7.292 0 0 1-1.407 4.313l4.451 4.454a1.126 1.126 0 0 1-1.592 1.592l-4.451-4.453a7.272 7.272 0 0 1-4.314 1.406A7.311 7.311 0 1 1 7.313 0a7.311 7.311 0 0 1 7.313 7.311m-7.313 5.062a5.063 5.063 0 1 0 0-10.126 5.063 5.063 0 0 0 0 10.126"
  })));
};
export default SvgSearch;